// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605070432/js/" + chunkId + "." + {"44":"0ab63d9a","225":"a6ecd4dd","481":"ef74cf91","486":"ff0b8962","770":"861de0ef"}[chunkId] + ".0.9101749012538254.chunk.js";
};